import React from "react";
import { observer } from "mobx-react-lite";
import { Label, theme } from "Application";
import { StudentTargetViewModel } from "./StudentTargetViewModel";
import { PanelContainer, Panel, Row, MobileResponsiveContainer, RowContent, PanelMainContent, PanelContent } from "./StudentTargetView.styles";

import { StudentSubTargetView } from "../StudentSubTarget/StudentSubTargetView";
import { ExclamationIconSVG } from "Assets/Icons/ExclamationIconSVG";

interface IStudentTargetViewProps {
    viewModel: StudentTargetViewModel;
}

export const StudentTargetView: React.FC<IStudentTargetViewProps> = observer(({ viewModel }) => {
    const { isMobile } = viewModel;

    return (
        <>
            <PanelContainer>
                <Panel>
                    <PanelContent>
                        <Label fontStyle="h4">{viewModel.reference}</Label>
                        {viewModel.showError && <ExclamationIconSVG backgroundcolor={theme.palette.common.error} color={theme.palette.common.white} />}
                    </PanelContent>
                </Panel>
                <PanelMainContent>
                    <Row>
                        <RowContent>
                            <Label fontStyle={"field"}>{viewModel.description}</Label>
                        </RowContent>
                    </Row>
                    {!isMobile && (
                        <>
                            <MobileResponsiveContainer>
                                {viewModel.subTargetViewModels.map((subTarget, index) => (
                                    <StudentSubTargetView viewModel={subTarget} key={subTarget.model.KEY} index={index} />
                                ))}
                            </MobileResponsiveContainer>
                        </>
                    )}
                </PanelMainContent>
            </PanelContainer>
            {isMobile && (
                <>
                    <MobileResponsiveContainer>
                        {viewModel.subTargetViewModels.map((subTarget, index) => (
                            <StudentSubTargetView viewModel={subTarget} key={subTarget.model.KEY} index={index} />
                        ))}
                    </MobileResponsiveContainer>
                </>
            )}
        </>
    );
});
